export default "__VITE_ASSET__pmzCaHr8__"